var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HorizontalMenu',{attrs:{"items":_vm.items,"size":"small","bottomLine":false,"value":_vm.value},on:{"onChange":function($event){return _vm.$emit('onChange', $event)},"onTabClick":function($event){return _vm.$emit('onTabClick', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }